// config.service.ts
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CryptoUtil } from "./decipher";

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    json: any;

    constructor(private http: HttpClient) { }

    loadConfig(): Promise<void> {
        return this.http.get('./assets/config/config.json', { responseType: 'text' }) // ✅ force text
            .toPromise()
            .then(async (encrypted: string) => {
                this.json = await CryptoUtil.decryptConfig(
                    encrypted,
                    "onnet.2025.pishow"
                );
            });
    }
}
